import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { LoadUserInfo } from '../../store/actions/user-info.actions';
import {
  getUserInfoData,
  getUserInfoFail,
  getUserInfoLoading,
  getUserInfoSuccess,
} from '../../store/selectors/user-info.selectors';

@Injectable({
  providedIn: 'root',
})
export class UserInfoFacade {
  constructor(private store: Store) {}

  userInfo$ = this.store.select(getUserInfoData);
  userInfoLoading$ = this.store.select(getUserInfoLoading);
  userInfoSuccess$ = this.store.select(getUserInfoSuccess);
  userInfoError$ = this.store.select(getUserInfoFail);

  getUserInfo(): void {
    this.store.dispatch(LoadUserInfo());
  }
}
